import React from 'react';
import App from './App';
import "./styles/index.css"
import "./styles/amo-tools-theme.css"
import {ThemeProvider} from "@mrocket/styles";
import {createRoot} from "react-dom/client";

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<ThemeProvider
  appearance={'light'}><App /></ThemeProvider>);
